export { default as WealthPlaybookDomainDisplay } from "./WealthPlaybookDomainDisplay";
